<template>
  <div id="chicang" class="Transactions_contrnt">
    <HeadBack title="查看实时持仓">
      <el-button @click="daochu" class="daochu" size="mini" type="primary" :disabled="daochudisabled" slot="btn" style="position:absolute;right:5px;top:6px;">导出实时持仓</el-button>
    </HeadBack>
    <el-table :data="PositionData" style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand cicang"
            v-for="(item,index) in props.row.webcontracts" :key="index" style="border-top:1px solid white;">
            <el-form-item label="合约代码：">
              <span>{{ item.underlyingNumber }}</span>
            </el-form-item>
            <el-form-item label="持仓编号：">
              <span>{{ item.contractShowCode }}</span>
            </el-form-item>
            <el-form-item label="期权类型：">
              <span>{{ item.optionsType }}</span>
            </el-form-item>
            <el-form-item label="标的进场价：">
              <span>{{ item.underlyingPrice }}</span>
            </el-form-item>
            <el-form-item label="持仓数量：">
              <span>{{ item.volume + item.quoteUnitName }}</span>
            </el-form-item>
            <el-form-item label="可用：">
              <span>{{ item.usableVolume + item.quoteUnitName }}</span>
            </el-form-item>
            <el-form-item label="买卖方向：">
              <span>{{ item.buySell }}</span>
            </el-form-item>
            <el-form-item label="权利金：">
              <span>{{ item.premium }}</span>
            </el-form-item>
            <el-form-item label="保证金：">
              <span>{{ item.margin }}</span>
            </el-form-item>
            <el-form-item label="参考市价：">
              <span>{{ item.lastPrice }}</span>
            </el-form-item>
            <el-form-item label="参考损益：">
              <span>{{ item.lastPriceProfit }}</span>
            </el-form-item>
            <el-form-item label="看涨看跌">
              <span>{{ item.callPut }}</span>
            </el-form-item>
            <el-form-item label="开仓日期：">
              <span>{{ item.openDate }}</span>
            </el-form-item>
            <!-- 新增字段，待字段 -->
            <el-form-item label="结算日期：">
              <span>{{ item.expiringDate }}</span>
            </el-form-item>
            <el-form-item label="报价时间：">
              <span>{{ changeTime(item.quoteTime) }}</span>
            </el-form-item>
            <el-form-item label="标的最新价：">
              <span>{{ item.currentUnderlyingPrice }}</span>
            </el-form-item>
            <el-form-item label="数量类型：">
              <span>{{ notionalPrincipalTypeSelFun(item.notionalPrincipalType) }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <div class="fengexian"></div>
      <el-table-column label="序号" type="index"> </el-table-column>
      <el-table-column label="持仓编号" prop="contractShowCode"> </el-table-column>
      <el-table-column label="合约代码" prop="underlyingNumber"> </el-table-column>
      <el-table-column label="到期日" prop="expiringDate"> </el-table-column>
    </el-table>
    <div class="block" style="display:flex;justify-content:center;">
      <el-pagination @size-change="handleSizeChange" @current-change="current" :current-page.sync="page" background
        :page-size="10" layout=" prev, pager, next" :total="total" @prev-click="prev" @next-click="next">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import HeadBack from '../components/HeadBack.vue'
  import axios from '../axios'
  import g from '@/components/Global.vue'
  export default {
    name: 'newCicang',
    data() {
      return {
        PositionData: [],
        daochudisabled: false,
        // 页码
        page: 1,
        total: 10,
        pageSize: 10,
      }
    },
    created() {
      this.PositionChange()
    },
    computed:{
      userID () {
        return this.$store.state.userID
      },
    },
    methods: {
      //持仓分页
      PositionChange(val) {
        axios.post('trade/queryCurrentTimeContract.do', this.qs.stringify({
          webClientBindId: this.userID,
          pageno: this.page,
          pagesize: this.pageSize
        })).then(data => {
          if (!data) {
            this.daochudisabled = true
            this.PositionData = []
            this.total = 1
            return 
          } else {
            this.daochudisabled = false
          }
          if(data.data.success) {
            this.PositionData = data.data.page.datas
            this.total = data.data.page.totalsize;
          }
          
        })
      },
      daochu() {
        window.open(`${g.baseURL}/client/inner/excel/exportRepairCurrentTimeClientContract.do?webClientBindId=${this.userID}`)
      },
      // 分页器的事件处理函数
      current(page) {
        this.page = page
      },
      prev(page) {
        this.page = page
      },
      next(page) {
        this.page = page
      },
      handleSizeChange(page) {
        this.pageSize = page
      },
      changeTime(val) {
        let arr =  val.split(" ")
        let str = ''
        if(arr[1].length < 6) {
          str = arr[1].substring(0, 1) + ":" + arr[1].substring(1, 3) + ":" + arr[1].substring(3, 5)
        } else {
          str = arr[1].substring(0, 2) + ":" + arr[1].substring(2, 4) + ":" + arr[1].substring(4, 6)
        }
        return arr[0] + " " + str
      },
    },
    components: {
      HeadBack
    },
    watch: {
      page() {
        this.PositionChange()
      },
      pageSize() {
        this.PositionChange()
      },
      $route (to , from) {
        if(to.name == 'newCicang') {
          this.PositionChange()
        }
      }
    },
  }

</script>

<style>
#chicang {
  margin-top: 42px;
}
</style>